import { ClickAwayListener } from '@mui/base'
import classNames from 'clsx'
import { bool, func, node, string } from 'prop-types'
import { useState } from 'react'

import ButtonAsLink from 'views/components/molecules/ButtonAsLink'

import './ButtonTooltip.scss'

const ButtonTooltip = ({
  text,
  inline,
  id,
  sideRendered,
  className,
  isVisible,
  small,
  buttonText,
  ButtonType,
  fullWidth,
  children,
  isDeclarative,
}) => {
  const containerClassName = classNames('m-ButtonTooltip', {
    [`m-ButtonTooltip--${sideRendered}`]: sideRendered,
    'm-ButtonTooltip--full-width': fullWidth,
  })

  const buttonClassName = classNames(
    'u-padding-xx-small--left u-no-margin u-font-weight--normal m-tooltipButton__text',
    {
      'a-h3': ButtonType !== ButtonAsLink,
    }
  )

  const [visible, setTooltipVisible] = useState(isVisible)

  const toggleTooltip = () => {
    if (isDeclarative) {
      setTooltipVisible(prev => !prev)
    }
  }

  const hideTooltip = () => {
    if (visible && isDeclarative) {
      setTooltipVisible(false)
    }
  }

  return (
    <ClickAwayListener onClickAway={hideTooltip}>
      <span className={containerClassName} data-tooltip-text={text}>
        <ButtonType
          type="button"
          inline={inline}
          name={id}
          ariaControls={id}
          ariaDescribedby={id}
          expanded={visible}
          ariaHaspopup
          isClientsideControlled
          data-clientside-hook={isDeclarative ? '' : 'tooltip__button'}
          className={className}
          small={small}
          onClick={toggleTooltip}
        >
          <span className="a-visuallyhidden">More info</span>
          {children}
          {buttonText && <span className={buttonClassName}>{buttonText}</span>}
        </ButtonType>
        <div
          className="m-ButtonTooltip__text"
          role="tooltip"
          id={id}
          aria-hidden={visible ? null : true}
        >
          {text}
        </div>
      </span>
    </ClickAwayListener>
  )
}

ButtonTooltip.propTypes = {
  text: string.isRequired,
  id: string.isRequired,
  className: string,
  sideRendered: string,
  isVisible: bool,
  small: bool,
  buttonText: string,
  ButtonType: func,
  inline: bool,
  fullWidth: bool,
  children: node,
  isDeclarative: bool,
}

ButtonTooltip.defaultProps = {
  sideRendered: 'top',
  isVisible: false,
  className: 'm-ButtonTooltip__button',
  small: null,
  buttonText: '',
  inline: false,
  fullWidth: false,
  ButtonType: ButtonAsLink,
  children: null,
  isDeclarative: false,
}

export default ButtonTooltip
